(function(){
  const $=(s,r=document)=>r.querySelector(s);
  const $$=(s,r=document)=>Array.from(r.querySelectorAll(s));
  const menu = $('[data-spc-menu]');

function spcOpenMenu() {
  if (!menu) return;
  menu.classList.add('is-open');
  document.body.classList.add('spc-menu-is-open');
}

function spcCloseMenu() {
  if (!menu) return;
  menu.classList.remove('is-open');
  document.body.classList.remove('spc-menu-is-open');
}

$$('[data-spc-menu-open]').forEach(btn => {
  btn.addEventListener('click', function(event) {
    event.preventDefault();
    spcOpenMenu();
  });
});

$$('[data-spc-menu-close]').forEach(btn => {
  btn.addEventListener('click', function(event) {
    event.preventDefault();
    event.stopPropagation();
    spcCloseMenu();
  });
});

function spcOpenMenu() {
  if (!menu) return;
  menu.classList.add('is-open');
}

function spcCloseMenu() {
  if (!menu) return;
  menu.classList.remove('is-open');
}

$$('[data-spc-menu-open]').forEach(btn => {
  btn.addEventListener('click', function(event) {
    event.preventDefault();
    spcOpenMenu();
  });
});

$$('[data-spc-menu-close]').forEach(btn => {
  btn.addEventListener('click', function(event) {
    event.preventDefault();
    event.stopPropagation();
    spcCloseMenu();
  });
});

  const audio=$('[data-spc-audio]');
  const audioBtn=$('[data-spc-audio-toggle]');
  if(audioBtn){
    audioBtn.addEventListener('click',()=>{
      const muted=!audioBtn.classList.contains('is-muted');
      audioBtn.classList.toggle('is-muted',muted);
      if(audio){
        audio.muted=muted;
        if(!muted){ audio.play().catch(()=>{}); } else { audio.pause(); }
      }
      document.dispatchEvent(new CustomEvent('spc:audio-toggle',{detail:{muted}}));
    });
  }

  function updateNYTime() {
    const el = document.getElementById('ny-time');
    if (!el) return;
    const nyNow = new Date(new Date().toLocaleString('en-US', { timeZone: 'America/New_York' }));
    const hours = nyNow.getHours();
    const minutes = String(nyNow.getMinutes()).padStart(2, '0');
    const seconds = String(nyNow.getSeconds()).padStart(2, '0');
    const period = hours >= 12 ? 'PM' : 'AM';
    const hour12 = String(((hours + 11) % 12 + 1)).padStart(2, '0');
    const startOfDay = new Date(nyNow);
    startOfDay.setHours(0, 0, 0, 0);
    const endOfDay = new Date(nyNow);
    endOfDay.setHours(24, 0, 0, 0);
    const elapsed = nyNow - startOfDay;
    const total = endOfDay - startOfDay;
    const dayPercent = ((elapsed / total) * 100).toFixed(1);
    const timeString = `${hour12}:${minutes}:${seconds} ${period}`;
    el.textContent = `NYC | ${timeString} | ${dayPercent}%`;
  }

  function updateNYCDateInfo() {
    const el = document.getElementById('nyc-dayinfo');
    if (!el) return;
    const now = new Date();
    const nyDate = new Date(now.toLocaleString('en-US', { timeZone: 'America/New_York' }));
    const weekday = nyDate.toLocaleString('en-US', { weekday: 'short', timeZone: 'America/New_York' }).toUpperCase();
    const month = String(nyDate.getMonth() + 1).padStart(2, '0');
    const day = String(nyDate.getDate()).padStart(2, '0');
    const year = String(nyDate.getFullYear()).slice(-2);
    const dayOfWeek = (nyDate.getDay() + 6) % 7;
    const startOfWeek = new Date(nyDate);
    startOfWeek.setDate(nyDate.getDate() - dayOfWeek);
    startOfWeek.setHours(0, 0, 0, 0);
    const totalWeekMs = 7 * 24 * 60 * 60 * 1000;
    const elapsedWeekMs = nyDate - startOfWeek;
    const percentWeek = ((elapsedWeekMs / totalWeekMs) * 100).toFixed(1);
    el.textContent = `${weekday} | ${month}-${day}-${year} | ${percentWeek}%`;
  }

  function updateCountdowns(){
    $$('[data-countdown]').forEach(el=>{
      const end=el.getAttribute('data-countdown'); if(!end)return;
      const d=new Date(end).getTime()-Date.now(); if(!Number.isFinite(d)||d<=0){el.textContent='00:00:00:00'; return;}
      const days=Math.floor(d/86400000), hours=Math.floor(d/3600000)%24, mins=Math.floor(d/60000)%60, secs=Math.floor(d/1000)%60;
      el.textContent=[days,hours,mins,secs].map(n=>String(n).padStart(2,'0')).join(':');
    });
  }

  function tick(){
    updateNYTime();
    updateNYCDateInfo();
    updateCountdowns();
  }
  tick();
  setInterval(tick,1000);

  function fracInches(value){
  const v = Number(value);
  if (!Number.isFinite(v)) return value || '';

  const rounded = Math.round(v * 4) / 4;
  const whole = Math.floor(rounded);
  const frac = Math.round((rounded - whole) * 4);

  const map = {
    0: '',
    1: '¼',
    2: '½',
    3: '¾',
    4: ''
  };

  if (frac === 0) return `${whole}"`;
  if (frac === 4) return `${whole + 1}"`;

  return whole ? `${whole} ${map[frac]}"` : `${map[frac]}"`;
}

function cmValue(value){
  const v=Number(value); if(!Number.isFinite(v)) return value || '';
  const cm=Math.round((v*2.54)*2)/2;
  return `${cm % 1 === 0 ? cm.toFixed(0) : cm.toFixed(1)}`;
}
  function renderSizeChart(wrap, unit = 'in') {
  const script = $('[data-size-chart-json]', wrap);
  const target = $('[data-size-chart-table]', wrap);
  if (!script || !target) return;

  let data;
  try {
    data = JSON.parse(script.textContent);
  } catch (e) {
    target.innerHTML = '';
    return;
  }

  if (typeof data === 'string') {
    try {
      data = JSON.parse(data);
    } catch (e) {}
  }

  const sizes = data.sizes || [];
  const measurements = data.measurements || [];

  if (!sizes.length || !measurements.length) {
    target.innerHTML = '';
    return;
  }

  const fmt = (val) => unit === 'cm' ? cmValue(val) : fracInches(val);

  const unitToggle = `
    <div class="spc-size-chart-toggle spc-size-chart-toggle-in-table">
      <button type="button" class="${unit === 'in' ? 'is-active' : ''}" data-size-unit="in">IN</button>
      <button type="button" class="${unit === 'cm' ? 'is-active' : ''}" data-size-unit="cm">CM</button>
    </div>
  `;

  let html =
    '<div class="spc-size-chart-scroll">' +
      '<table class="spc-size-chart-table">' +
        '<thead>' +
          '<tr>' +
            `<th class="spc-size-chart-unit-cell">${unitToggle}</th>` +
            sizes.map(s => `<th>${s}</th>`).join('') +
          '</tr>' +
        '</thead>' +
        '<tbody>';

  measurements.forEach(row => {
    html +=
      `<tr><td>${row.label || ''}</td>` +
      sizes.map(size => `<td>${fmt((row.values || {})[size])}</td>`).join('') +
      '</tr>';
  });

  html += '</tbody></table></div>';
  target.innerHTML = html;

  $$('[data-size-unit]', target).forEach(btn => {
    btn.addEventListener('click', () => {
      renderSizeChart(wrap, btn.dataset.sizeUnit || 'in');
    });
  });
}

$$('[data-size-chart-wrap]').forEach(wrap => {
  renderSizeChart(wrap, 'in');
});

  const popup = $('[data-spc-popup]');
const popupPath = window.location.pathname === '/' ? 'home' : window.location.pathname.replace(/[^a-z0-9]/gi, '_');
const popupKey = 'spc_signup_popup_closed_until_' + popupPath;
const popupSignedKey = 'spc_signup_popup_signed_up';

const popupCloseDuration = popup ? parseInt(popup.dataset.closeDuration || '1', 10) : 1;
const popupCloseUnit = popup ? popup.dataset.closeUnit || 'days' : 'days';

function spcPopupCooldownMs() {
  const duration = Math.min(Math.max(popupCloseDuration || 1, 1), 100);

  if (popupCloseUnit === 'minutes') {
    return duration * 60 * 1000;
  }

  if (popupCloseUnit === 'hours') {
    return duration * 60 * 60 * 1000;
  }

  return duration * 24 * 60 * 60 * 1000;
}

function spcPopupClosedRecently() {
  const closedUntil = localStorage.getItem(popupKey);
  if (!closedUntil) return false;
  return Date.now() < Number(closedUntil);
}

function spcOpenPopup() {
  if (!popup) return;
  if (localStorage.getItem(popupSignedKey) === 'true') return;
  if (spcPopupClosedRecently()) return;

  const delay = parseInt(popup.dataset.delay || '2500', 10);
  setTimeout(() => {
    popup.classList.add('is-open');
  }, delay);
}

function spcClosePopup(saveClose) {
  if (!popup) return;
  popup.classList.remove('is-open');

  if (saveClose) {
    const hideUntil = Date.now() + spcPopupCooldownMs();
    localStorage.setItem(popupKey, String(hideUntil));
  }
}

spcOpenPopup();

$$('[data-spc-popup-close]').forEach(btn => {
  btn.addEventListener('click', () => {
    spcClosePopup(true);
  });
});
})();



// SPC fixed nav behavior.
// Announcement bar scrolls away. Nav becomes fixed when it reaches top.
(function () {
  function initSPCStickyNav() {
    const nav = document.querySelector('.spc-nav-sticky');
    if (!nav) return;

    let placeholder = document.querySelector('.spc-nav-placeholder');

    if (!placeholder) {
      placeholder = document.createElement('div');
      placeholder.className = 'spc-nav-placeholder';
      nav.parentNode.insertBefore(placeholder, nav);
    }

    let navStart = 0;
    let navHeight = 0;

    function measure() {
      nav.classList.remove('is-fixed');
      placeholder.classList.remove('is-active');
      placeholder.style.height = '0px';

      const rect = nav.getBoundingClientRect();
      navStart = rect.top + window.pageYOffset;
      navHeight = nav.offsetHeight;

      update();
    }

    function update() {
      if (window.pageYOffset >= navStart) {
        nav.classList.add('is-fixed');
        placeholder.classList.add('is-active');
        placeholder.style.height = navHeight + 'px';
      } else {
        nav.classList.remove('is-fixed');
        placeholder.classList.remove('is-active');
        placeholder.style.height = '0px';
      }
    }

    measure();

    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', measure);

    document.addEventListener('shopify:section:load', function () {
      setTimeout(initSPCStickyNav, 100);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSPCStickyNav);
  } else {
    initSPCStickyNav();
  }
})();





// SPC hero slideshow
(function () {
  function initSPCHeroSlideshows() {
    document.querySelectorAll('[data-spc-hero-slider]').forEach(function (slider) {
      if (slider.dataset.spcHeroInitialized === 'true') return;
      slider.dataset.spcHeroInitialized = 'true';

      const slides = Array.from(slider.querySelectorAll('[data-spc-hero-slide]'));
      if (!slides.length) return;

      slides.forEach(function (slide, index) {
        slide.classList.toggle('is-active', index === 0);
      });

      if (slides.length < 2) return;

      const fadeDuration = parseInt(slider.dataset.fadeDuration || '1200', 10);
      const slideDelay = parseInt(slider.dataset.slideDelay || '2500', 10);
      const intervalTime = Math.max(fadeDuration + slideDelay, 500);

      let current = 0;

      setInterval(function () {
        slides[current].classList.remove('is-active');
        current = (current + 1) % slides.length;
        slides[current].classList.add('is-active');
      }, intervalTime);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSPCHeroSlideshows);
  } else {
    initSPCHeroSlideshows();
  }

  document.addEventListener('shopify:section:load', function () {
    setTimeout(initSPCHeroSlideshows, 100);
  });
})();






// SPC product page image dots
(function () {
  function initSPCProductDots() {
    const media = document.querySelector('[data-spc-product-media]');
    if (!media) return;

    const items = Array.from(media.querySelectorAll('[data-spc-product-media-item]'));
    const dots = Array.from(document.querySelectorAll('[data-spc-product-dot]'));

    if (!items.length || !dots.length) return;

    function setActive(index) {
      dots.forEach(function (dot) {
        dot.classList.toggle('is-active', dot.dataset.index === String(index));
      });
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        const index = parseInt(dot.dataset.index || '0', 10);
        const item = items[index];
        if (!item) return;

        if (window.matchMedia('(max-width: 991px)').matches) {
          media.scrollTo({
            left: item.offsetLeft,
            behavior: 'smooth'
          });
        } else {
          window.scrollTo({
            top: item.getBoundingClientRect().top + window.pageYOffset,
            behavior: 'smooth'
          });
        }

        setActive(index);
      });
    });

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(function (entries) {
        let bestEntry = null;

        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          if (!bestEntry || entry.intersectionRatio > bestEntry.intersectionRatio) {
            bestEntry = entry;
          }
        });

        if (bestEntry) {
          setActive(bestEntry.target.dataset.index || 0);
        }
      }, {
        root: window.matchMedia('(max-width: 991px)').matches ? media : null,
        threshold: [0.35, 0.55, 0.75]
      });

      items.forEach(function (item) {
        observer.observe(item);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSPCProductDots);
  } else {
    initSPCProductDots();
  }

  document.addEventListener('shopify:section:load', function () {
    setTimeout(initSPCProductDots, 100);
  });
})();




// SPC notify popup: opens only when a product notify button is clicked.
(function () {
  function initSPCNotifyPopup() {
    const popup = document.querySelector('[data-spc-notify-popup]');
    if (!popup) return;

    function openPopup(event) {
      if (event) event.preventDefault();
      popup.classList.add('is-open');
      document.documentElement.classList.add('spc-notify-is-open');
      document.body.classList.add('spc-notify-is-open');
    }

    function closePopup(event) {
      if (event) event.preventDefault();
      popup.classList.remove('is-open');
      document.documentElement.classList.remove('spc-notify-is-open');
      document.body.classList.remove('spc-notify-is-open');
    }

    document.querySelectorAll('[data-spc-notify-open]').forEach(function (button) {
      if (button.dataset.spcNotifyBound === 'true') return;
      button.dataset.spcNotifyBound = 'true';
      button.addEventListener('click', openPopup);
    });

    popup.querySelectorAll('[data-spc-notify-close]').forEach(function (button) {
      if (button.dataset.spcNotifyCloseBound === 'true') return;
      button.dataset.spcNotifyCloseBound = 'true';
      button.addEventListener('click', closePopup);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && popup.classList.contains('is-open')) closePopup(event);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSPCNotifyPopup);
  } else {
    initSPCNotifyPopup();
  }

  document.addEventListener('shopify:section:load', initSPCNotifyPopup);
})();







/* SPC AJAX CART DRAWER */
(function () {
  const root = window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';

  const drawer = document.querySelector('[data-spc-cart-drawer]');
  const toggleWrap = document.querySelector('[data-spc-cart-toggle-wrap]');
  const toggleButtons = document.querySelectorAll('[data-spc-cart-open]');
  const closeButtons = document.querySelectorAll('[data-spc-cart-close]');
  const countEls = document.querySelectorAll('[data-spc-cart-count]');
  const itemsEl = document.querySelector('[data-spc-cart-items]');
  const footEl = document.querySelector('[data-spc-cart-foot]');
  const subtotalEl = document.querySelector('[data-spc-cart-subtotal]');
  const noteEl = document.querySelector('[data-spc-cart-note]');

  if (!drawer || !itemsEl) return;

  function endpoint(path) {
    return root + path.replace(/^\//, '');
  }

  function money(cents) {
    const amount = Number(cents || 0) / 100;
    const currency = window.Shopify && Shopify.currency && Shopify.currency.active ? Shopify.currency.active : 'USD';

    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: currency,
      minimumFractionDigits: amount % 1 === 0 ? 0 : 2,
      maximumFractionDigits: 2
    }).format(amount);
  }

  function escapeHTML(value) {
    return String(value || '').replace(/[&<>"']/g, function (char) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
      }[char];
    });
  }

  function openCart() {
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('spc-cart-is-open');
    document.body.classList.add('spc-cart-is-open');
  }

  function closeCart() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('spc-cart-is-open');
    document.body.classList.remove('spc-cart-is-open');
  }

  function updateCount(count) {
    countEls.forEach(function (el) {
      el.textContent = count;
    });

    if (toggleWrap) {
  toggleWrap.hidden = false;
}
  }

  function renderCart(cart) {
    updateCount(cart.item_count || 0);

    if (subtotalEl) subtotalEl.textContent = money(cart.total_price);
    if (noteEl && document.activeElement !== noteEl) noteEl.value = cart.note || '';

    if (footEl) footEl.hidden = !cart.item_count;

    if (!cart.items || !cart.items.length) {
      itemsEl.innerHTML = '<p class="spc-cart-empty">Your cart is empty.</p>';
      return;
    }

    itemsEl.innerHTML = cart.items.map(function (item) {
      const image = item.image
        ? '<img src="' + item.image + '&width=160" alt="' + escapeHTML(item.product_title) + '">'
        : '<div></div>';

      const variant = item.variant_title && item.variant_title !== 'Default Title'
        ? '<div class="spc-cart-item-variant">' + escapeHTML(item.variant_title) + '</div>'
        : '';

      return (
  '<div class="spc-cart-item" data-line="' + item.key + '">' +
    image +
    '<div>' +
      '<div class="spc-cart-item-title">' + escapeHTML(item.product_title) + '</div>' +
      variant +
      '<div class="spc-cart-item-qty-text">Qty: ' + item.quantity + '</div>' +
      '<button type="button" class="spc-cart-remove" data-spc-cart-remove>Remove</button>' +
    '</div>' +
    '<div class="spc-cart-price">' + money(item.final_line_price) + '</div>' +
  '</div>'
);
    }).join('');
  }

  function getCart() {
    return fetch(endpoint('/cart.js'), {
      credentials: 'same-origin'
    })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        renderCart(cart);
        return cart;
      });
  }

  function changeItem(key, quantity) {
    return fetch(endpoint('/cart/change.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: key,
        quantity: quantity
      })
    })
      .then(function (res) { return res.json(); })
      .then(renderCart);
  }

  function saveNote(note) {
    return fetch(endpoint('/cart/update.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        note: note
      })
    });
  }

  let noteTimer;

  if (noteEl) {
    noteEl.addEventListener('input', function () {
      clearTimeout(noteTimer);
      noteTimer = setTimeout(function () {
        saveNote(noteEl.value);
      }, 500);
    });
  }

  toggleButtons.forEach(function (button) {
  button.addEventListener('click', function () {
    openCart();
    getCart();
  });
});

  closeButtons.forEach(function (button) {
    button.addEventListener('click', closeCart);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && drawer.classList.contains('is-open')) {
      closeCart();
    }
  });

  itemsEl.addEventListener('click', function (event) {
    const itemEl = event.target.closest('[data-line]');
    if (!itemEl) return;

    const key = itemEl.getAttribute('data-line');
    const input = itemEl.querySelector('[data-spc-cart-qty]');
    const currentQty = Number(input ? input.value : 1);

    if (event.target.matches('[data-spc-cart-minus]')) {
      changeItem(key, Math.max(0, currentQty - 1));
    }

    if (event.target.matches('[data-spc-cart-plus]')) {
      changeItem(key, currentQty + 1);
    }

    if (event.target.matches('[data-spc-cart-remove]')) {
      changeItem(key, 0);
    }
  });

  itemsEl.addEventListener('change', function (event) {
    if (!event.target.matches('[data-spc-cart-qty]')) return;

    const itemEl = event.target.closest('[data-line]');
    if (!itemEl) return;

    const key = itemEl.getAttribute('data-line');
    const qty = Math.max(0, Number(event.target.value || 0));

    changeItem(key, qty);
  });

  document.addEventListener('submit', function (event) {
    const form = event.target;

    if (!form.matches('form[action*="/cart/add"]')) return;

    event.preventDefault();

    const submitButton = form.querySelector('[type="submit"]');
    const originalText = submitButton ? submitButton.textContent : '';

    if (submitButton) {
      submitButton.disabled = true;
      submitButton.textContent = 'ADDING...';
    }

    fetch(endpoint('/cart/add.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Accept': 'application/json'
      },
      body: new FormData(form)
    })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (data) { throw data; });
        return res.json();
      })
      .then(function () {
        return getCart();
      })
      .then(function () {
        openCart();
      })
      .catch(function (error) {
        alert(error && error.description ? error.description : 'Could not add this item to cart.');
      })
      .finally(function () {
        if (submitButton) {
          submitButton.disabled = false;
          submitButton.textContent = originalText;
        }
      });
  });

  getCart();
})();